/*
    @file:
        fullpage.js

    @description:
        Core Javascript file that handles
        home page section scrolling
*/

// Variables
var $                   = require( 'jquery' );
var jQuery              = require( 'jquery' );

var AOS                 = require('aos');

// Events
$(document).ready(function () {
    $('.hamburger .btn-menu').on('click', function() {
        $('body').addClass('overlay-menu-active');
    });


    

    $('.menu-close .btn-menu-close').on('click', function() {
        $('body').removeClass('overlay-menu-active');
    });

    $('.header .cart').on('click', function() {
        $('body').addClass('sidebar--active');
    });

    $('.cart-sidebar .close').on('click', function() {
        $('body').removeClass('sidebar--active');
    });

    $('.section-vision .title-row').on('click', function() {
        $(this).siblings('.title-row').removeClass('active');
        $(this).addClass('active');
    });

    $('.section-book .content-col h3').on('click', function() {
        $(this).closest('.content-col').siblings('.content-col').removeClass('active');
        $(this).closest('.content-col').addClass('active');
    });

    var offsetTop;

    if($(window).width() > 992) {
        offsetTop = 120;
    } else if($(window).width() <= 992) {
        offsetTop = 120;
    }

    $(".hero-scroll .scroll-down").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".filters-toolbar").offset().top - offsetTop
        }, 800);
    });

    $(".cover-book a.scrollTo").click(function(e) {
        e.preventDefault();

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".page-book").offset().top - offsetTop
        }, 800);
    });

    if($('.page-project').length) {
        $(".scroll-down .btn-next").click(function() {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".page-project").offset().top - offsetTop
            }, 800);
        });
    }

    if($('.page-about').length) {
        $(".scroll-down .btn-next").click(function() {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".page-about").offset().top - offsetTop
            }, 800);
        });
    }

    $('.page-book .sidemenu a').on('click', function(e) {
        e.preventDefault();
        var hash = $(this).prop('hash').substr(1);

        $('.page-book .sidemenu a').each(function() {
            $(this).removeClass('active');
        });

        $(this).addClass('active');
        $('.page-book .tab').each(function() {
            $(this).removeClass('active');

            if($(this).data('tab') === hash) {
                $(this).addClass('active');
            }
        });

        AOS.refresh();
    });

    $('.page-shop--single .sidemenu a').on('click', function(e) {
        e.preventDefault();
        var hash = $(this).prop('hash').substr(1);

        $('.page-shop--single .sidemenu a').each(function() {
            $(this).removeClass('active');
        });

        $(this).addClass('active');
        $('.page-shop--single .tab').each(function() {
            $(this).removeClass('active');

            if($(this).data('tab') === hash) {
                $(this).addClass('active');
            }
        });

        AOS.refresh();
    });

    $('.video .btn-play').each(function() {
        $(this).on('click', function(ev){
            $(this).parent().addClass('playerActive');
            $(this).siblings("iframe")[0].src += "?autoplay=1";
            ev.preventDefault();
        });
    });


    var overlayVideoSrc;

    $('.cover-project .btn-play').each(function() {
        $(this).on('click', function(ev){
            $('body').addClass('overlay-video-active');
            overlayVideoSrc = $('.cover-project .video-overlay iframe').attr('src');
            $('.cover-project .video-overlay iframe')[0].src += "?autoplay=1";
            ev.preventDefault();
        });
    });

    $('.cover-base .btn-play').each(function() {
        $(this).on('click', function(ev){
            $('body').addClass('overlay-video-active');
            overlayVideoSrc = $('.cover-base .video-overlay iframe').attr('src');
            $('.cover-base .video-overlay iframe')[0].src += "?autoplay=1";
            ev.preventDefault();
        });
    });

    $('.video-close').on('click', function() {
        $('body').removeClass('overlay-video-active');

        if($('.cover-base').length) {
            $('.cover-base .video-overlay iframe').attr('src', overlayVideoSrc);
        } else {
            $('.cover-project .video-overlay iframe').attr('src', overlayVideoSrc);
        }
    });
});